/* eslint-disable import/no-unresolved */
import React, { memo, useContext } from 'react';
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import defaultVariantIcon from 'images/dashboard/main-img-holder.png';
import DrownArrowIcon from 'images/arrow-down-24.svg';
import ArrowUpIcon from 'images/arrow-up-24.svg';

import CheckBoxMC from "../../components/CheckBoxMC";
import IconMC from "../../components/IconMC";
import ProductPriceDisplay from "./components/search-products/ProductPriceDisplay";
import { canBeSelected } from "../../../util/productUtils";

const ProductListHeader = ({
  product,
  eventKey,
  callback,
  handleSelectProduct
}) => {
  const { activeEventKey } = useContext(AccordionContext);
  const { t } = useTranslation('Orders');

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);

  const isCurrentEventKey = activeEventKey?.includes(String(eventKey));

  const hasCombinations = !isEmpty(product.product_variant_combinations);
  const { currency_code, currency_symbol } = retailer_info;

  const imageUrl = product.url || defaultVariantIcon;

  return (
    <div className="tw-flex tw-w-full">
      <div
        className={`tw-flex tw-items-center tw-py-2.5 tw-justify-between tw-w-full ${hasCombinations ? 'tw-cursor-pointer' : ''}`}
        onClick={decoratedOnClick}
      >
        <div className={`tw-flex tw-items-center ${hasCombinations ? 'tw-w-full' : 'md:tw-w-1/2'}`}>
          {canBeSelected(product) ? (
            <CheckBoxMC
              checked={product.wasSelected || product.selected || false}
              onChange={
                product.wasSelected
                  ? () => { }
                  : (e) => handleSelectProduct(e, product, product)
              }
              className={`tw-w-3 tw-h-3 ${product.wasSelected ? '!tw-text-gray-300 !tw-accent-gray-300' : ''}`}
            />
          ) : (
            <div className="tw-w-4" />
          )}

          <div className="tw-flex tw-pl-6 tw-pr-4 tw-gap-2.5">
            <div
              className="tw-w-[42px] tw-h-[42px] tw-rounded-[5px] tw-flex-shrink-0 tw-bg-gray-200 tw-bg-contain tw-bg-no-repeat tw-bg-center"
              style={{ backgroundImage: `url(${imageUrl})` }}
            />

            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-flex-col">
                <span className={`${product.wasSelected ? 'tw-text-gray-400' : 'tw-text-gray-950'}`}>{product.title}</span>
                {hasCombinations && (
                  <div className="tw-flex">
                    <span className="tw-px-2.5 tw-py-[2px] tw-rounded-[5px] tw-bg-gray-50 tw-text-gray-700 tw-text-xs">
                      {product.product_variant_combinations.length}
                      {' '}
                      {t('search.variants')}
                    </span>
                  </div>
                )}
              </div>
              {product.wasSelected && !hasCombinations && (
                <div className="tw-ml-[5px]">
                  <div className="tw-text-xs tw-text-gray-400">
                    <span className="tw-mr-[5px]">
                      <IconMC
                        name="info-outline"
                        className="tw-text-gray-500"
                        size="base"
                      />
                    </span>
                    <span>{t('search.addedProduct')}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {!hasCombinations && (
          <>
            <div className="md:tw-col-span-3 tw-text-right px-0">
              <span className={`${product.wasSelected ? 'tw-text-gray-300' : 'tw-text-gray-700'} ${Number(product.quantity) <= 0 ? 'tw-text-red-500' : ''}`}>
                {product.quantity}
                {' '}
                {t('search.inStock')}
              </span>
            </div>
            <ProductPriceDisplay
              item={product}
              currency_symbol={currency_symbol}
              currency_code={currency_code}
              t={t}
            />
          </>
        )}
      </div>

      {hasCombinations && (
        <button
          type="button"
          className="tw-py-5 tw-border-0"
          onClick={decoratedOnClick}
          style={{ width: 35 }}
        >
          <div className="tw-flex">
            <img src={isCurrentEventKey ? ArrowUpIcon : DrownArrowIcon} className="tw-mr-2.5" />
          </div>
        </button>
      )}
    </div>
  );
};

export default memo(ProductListHeader);
